import React from "react";
import "./ForwardedBadge.css";

const ForwardedBadge = React.memo(({ label }) => (
  <p className="m-0 forwarded-badge">
    <span className="material-symbols-outlined forwarded-badge__icon">forward</span>
    {label}
  </p>
));

export default ForwardedBadge;
